export default "__VITE_ASSET__0b55c963__"